import { Skeleton, Stack } from "@mui/material";

type Props = {};

const CustomerTableLoadingMobile = (props: Props) => {
  return (
    <Stack spacing={2} justifyContent="center">
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={60}
        width="93vw"
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={60}
        width="93vw"
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={60}
        width="93vw"
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={60}
        width="93vw"
      />
    </Stack>
  );
};

export default CustomerTableLoadingMobile;
